<template>
  <div>
    <div id='container'/>
    <div class="tempCanvases">
      <img crossorigin='anonymous' @load='onLoadImgFinished1' :src='this.usnoSrc'     ref='tempImg1' id='konvaImg1' class='hidden' onerror="this.src='darth.png'"/>
      <img crossorigin='anonymous' @load='onLoadImgFinished2' :src='this.panstarrSrc' ref='tempImg2' id='konvaImg2' class='hidden' onerror="this.src='darth.png'"/>

      <canvas id="t1" :width="ROISize" :height="ROISize" ref="tempCanvas1" class='hidden'/>
      <canvas id="t2" :width="ROISize" :height="ROISize" ref="tempCanvas2" class='hidden'/>

      <canvas id="ai1id" :width="konvaImg1Width" :height="konvaImg1Height" ref="ai1" class='hidden'/>
      <canvas id="ai2id" :width="konvaImg2Width" :height="konvaImg2Height" ref="ai2" class='hidden'/>


      <!-- temporarily images and canvasses for computing the next candidate -->
      <img crossorigin='anonymous' :src='this.NextUsnoSrc1' ref='NextImg1x' id='NextImg1x' class='hidden' onerror="this.src='darth.png'"/>
      <img crossorigin='anonymous' :src='this.NextPS1Src1'  ref='NextImg1y' id='NextImg1y' class='hidden' onerror="this.src='darth.png'"/>
      <img crossorigin='anonymous' :src='this.NextUsnoSrc2' ref='NextImg2x' id='NextImg2x' class='hidden' onerror="this.src='darth.png'"/>
      <img crossorigin='anonymous' :src='this.NextPS1Src1'  ref='NextImg2y' id='NextImg2y' class='hidden' onerror="this.src='darth.png'"/>

      <canvas id="NextCanvas1x" :width="konvaImg1Width" :height="konvaImg1Height" ref="NextCanvas1x" class='hidden'/>
      <canvas id="NextCanvas1y" :width="konvaImg2Width" :height="konvaImg2Height" ref="NextCanvas1y" class='hidden'/>
      <canvas id="NextCanvas2x" :width="konvaImg1Width" :height="konvaImg1Height" ref="NextCanvas2x" class='hidden'/>
      <canvas id="NextCanvas2y" :width="konvaImg2Width" :height="konvaImg2Height" ref="NextCanvas2y" class='hidden'/>
      <!-- end of temporarily canvasses for computing the next candidate -->



    </div>
    <!-- <div class="star-matching__object-canvases">
      <canvas style='margin-right: 5px' :width="ROISize" :height="ROISize" ref="xs"/>
      <canvas style='margin-right: 5px' :width="ROISize" :height="ROISize" ref="ys"/>
      <canvas style='margin-right: 5px' :width="ROISize" :height="ROISize" ref="zs"/>
    </div> -->
    <div class="thresholds-wrapper" :style="{'background-image': 'url(' + baseUrl + 'images/wood-texture.jpg)'}">
      <div class="padding">
      </div>
      <button :class="['blink-button', {'threshold-active' : blinking }]" @click="toggleBlink">FLASH</button>
      THRESHOLD
      <div class="threshold-container">
        <button
          :class="['threshold-button', {'threshold-active': filters.konvaImg1.hasThreshold }]"
          @click="handleToggleThreshold('konvaImg1')">
          1
        </button>
        <RangeSlider
          img-id="konvaImg1"
          type="range"
          max="100"
          min="0"
          v-model="filters.konvaImg1.thresholdValue"
          @input="handleThresholdValueChange"/>
      </div>
      <div class="threshold-container">
        <button
          :class="['threshold-button', {'threshold-active': filters.konvaImg2.hasThreshold }]"
          @click="handleToggleThreshold('konvaImg2')">
          2
        </button>
        <RangeSlider
          img-id="konvaImg2"
          type="range"
          max="100"
          min="0"
          v-model="filters.konvaImg2.thresholdValue"
          @input="handleThresholdValueChange"/>
      </div>
    </div>
  </div>
</template>
<script>

import Konva from 'konva/konva.js'
import {mapState, mapMutations} from 'vuex'
import {debounce} from 'lodash'
import {getRChannel} from '@/utils/canvas'
import {computeCorrelation} from '@/utils/correlation'
// import {subtract} from '@/utils/linalg'
import {binarize, labelObjects, getAsEqualSizedObjects} from '@/utils/transformation'
// import {meanFilter} from '@/utils/filters'
import RangeSlider from '@/components/RangeSlider.vue'
import {IMG__UPDATE_TRANSFORMATION, IMG__TOGGLE_THRESHOLD, IMG__UPDATE_THRESHOLD_VALUE} from '@/store/types'
import {KEY_CODES} from '@/utils/key-codes'
import {proj} from '@/utils/linalg.js'

export default {
  name: 'StarMatching',
  props: {
    filters: Object, // Filter settings for each image
    usnoSrc: String, // URL for USNO image
    panstarrSrc: String, // URL for PanSTARR image
    isAccuracyValid: Boolean // True if objects were detected within USNO ROI,
                             // false otherwise
  },
  components: {RangeSlider},
  data: function() {
    return {
      // The size in pixels of the Region of Interest (ROI)
      ROISize: 200,
      debounced: null, // A reference to a method that is debounced (useful to cancel it in case the action is executed again)
      blinking: false,
      blink: false,
      blinkingEngine: {},
      baseUrl: process.env.BASE_URL,
      width: window.innerWidth,
      height: window.innerHeight,
      konvaImg1: new Konva.Image({
        x: 0,
        y: 0.15 * window.innerHeight,
        width: 0.35 * window.innerWidth,
        height: 0.35 * window.innerWidth,
        name: 'img1',
        stroke: '#342',
        strokeWidth: 1,
        draggable: false
      }),
      konvaImg2: new Konva.Image({
        x: 0,
        y: (window.innerWidth > window.innerHeight ? 0.15 : 0.5 ) * window.innerHeight,
        width: 0.35 * window.innerWidth,
        height: 0.35 * window.innerWidth,
        name: 'img2',
        strokeWidth: 1,
        draggable: true
      }),
      transformer: null,
      imgLayer: null,
      // Cache USNO array which represents equal sized objects in its ROI.
      // This helps to make the computations more efficient as the USNO
      // ROI is static
      xsEqualSized: [],
      konvaImg1Width: 88, //why cannot these be set dynamically?
      konvaImg1Height: 88,
      konvaImg2Width: 600,
      konvaImg2Height: 600,
      nx: 30, // initialisation HARDCODED - check next lines!
      ny: 31, // initialisation HARDCODED - check next lines!
      projx: Array(30).fill().map(() => Array(7744).fill().map(()   => Math.random()) ), // dimensions hardcoded )-:
      projy: Array(31).fill().map(() => Array(360000).fill().map(() => Math.random()) ), // dimensions hardcoded )-:
      imgCounter: 0,

      // nextImg
      nextImg: 111,
      nextImg1: 113,
      nextImg2: 114,
      NextUsnoSrc1: 'http://r01.ds.cs.umu.se/getimage_mongo.php?image=113&filter=1&cat=USNO',
      NextPS1Src1:  'http://r01.ds.cs.umu.se/getimage_mongo.php?image=113&filter=1&cat=PS1',
      NextUsnoSrc2: 'http://r01.ds.cs.umu.se/getimage_mongo.php?image=114&filter=1&cat=USNO',
      NextPS1Src2:  'http://r01.ds.cs.umu.se/getimage_mongo.php?image=114&filter=1&cat=PS1',
      status_atBeginMission: true,
      status_atEndMission: false,
    }
  },
  watch: {
    // Handle image 2 position when when any of its attributes changes (e.g.,
    // position, width, height, or rotation)
    'konvaImg2.attrs': {
      handler: function() {
        //TODO! This doesn't seem to work
        // Cancel previously debounced call (if any)
        if(this.debounced && this.debounced.cancel) {
          this.debounced.cancel()
        }
        // (Re-)register debounce method
        this.debounced = debounce(this.handleImgPositionChange, 250)
        // Execute debounced method
        this.debounced(this.$refs.tempImg2)
      },
      deep: true
    },
    'transformer': {
      handler: function() {
        // Cancel previously debounced call (if any)
        if(this.debounced && this.debounced.cancel) {
          this.debounced.cancel()
        }
        // (Re-)register debounce method
        this.debounced = debounce(this.handleImgPositionChange, 250)
        // Execute debounced method
        this.debounced(this.$refs.tempImg2)
      },
      deep: true
    },
    'filters.konvaImg1': {
      handler: function() {
        this.configureImageFilters('konvaImg1')
        this.imgLayer.draw()
      },
      deep: true
    },
    'filters.konvaImg2': {
      handler: function() {
        this.configureImageFilters('konvaImg2')
        this.imgLayer.draw()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      D: ({D}) => D,
      AI_Accuracy: ({AI_Accuracy}) => AI_Accuracy
    }),
  },
  mounted: function() {
    let Dtemp = []
    for(let i = 0; i < this.nx; i += 1)
      Dtemp.push(Array(this.ny).fill(0))
    this.updateD(Dtemp)
    this.initializeKonvaStage()
  },

  methods: {
    ...mapMutations([
      'updateD',
      'updateNextCandidate',
      'update_AI_accuracy',
      'update_loading'
    ]),

  im2arr: function (canvas, projm) {
      let x = getRChannel(canvas, canvas.width, canvas.height)//Array(100).fill(42)
      let xp = proj(x,projm)
      let vx = xp.reduce((a,b)=>a+b**2,0.0)
      if (vx < 1e-18) {
        return xp;}
      else {
        xp = xp.map( z=>z/Math.sqrt(vx) );
        return xp;}
    },





    computeAIAccuracy: function () {
      if (this.status_atBeginMission) {


        let xp = this.im2arr(this.$refs['ai1'],this.projx)
        let yp = this.im2arr(this.$refs['ai2'],this.projy)

        // compute x'*D*y
        // let v = Math.floor(Math.random() * 100)
        let c = 0;
        for (var i=0; i < this.nx; i++)
          for (var j=0; j < this.ny; j++) {
            c+=xp[i] * this.D[i][j] * yp[j];
          }
        c = Math.abs(c)

        // normalise
        let xn = new Array(this.nx).fill().map(()   => (2*Math.random()-1))
        let normxn = xn.reduce((a,c)=> a+c**2,0.0)
        xn = xn.map(z=>z/normxn)

        let yn = new Array(this.ny).fill().map(()   => (2*Math.random()-1))
        let normyn = xn.reduce((a,c)=> a+c**2,0.0)
        yn = yn.map(z=>z/normyn)

        let cn = 0;
        for (var i1=0; i1 < this.nx; i1++)
          for (var j1=0; j1 < this.ny; j1++) {
            cn+=xn[i1] * this.D[i1][j1] * yn[j1];
          }
        cn = Math.abs(cn)

        // output transformation
        let min_threshold = 1+4*Math.random()
        let acc = 0
        if (cn>0) {  acc =  Math.max( min_threshold, (min_threshold+Math.min(95,Math.abs(c/cn))) );
        } else { acc = min_threshold;}

        console.log("AI accuracy for the present mission:", acc)
        this.status_atBeginMission = false
        this.status_atEndMission   = true
        this.update_AI_accuracy(acc)
        return acc
      }
      return 0
    },



    updateAI: function(update) {
      if (this.status_atEndMission) {
        if (update) {
          let Dtemp = Array(this.nx)
          for (let i = 0; i < Dtemp.length; i += 1) Dtemp[i] = [...this.D[i]]

          var xp = this.im2arr(document.getElementById('ai1id'),this.projx)
          var yp = this.im2arr(document.getElementById('ai2id'),this.projy)

          // actual update
          //   only update when MANaccuracy>AIaccuracy ('beat the AI')
          // 0.2  is the hardcoded learning rate
          for (var ix = 0; ix < this.nx; ix++) {
            for (var iy = 0; iy < this.ny; iy++) {
              Dtemp[ix][iy] += 0.2 * xp[ix] * yp[iy];
            }
          }
          console.log("Updated D to", this.D[0][0])

          this.updateD(Dtemp)
          let next = this.searchAI()
          this.updateNextCandidate( next )
        }
        this.status_atEndMission = false
        this.status_atBeginMission = true
      }
    },

    // The AI decides on which candidate to choose nextCandidate
    // This method implements this logic: it grabs 2 new missions, and decides which one is next
    searchAI: function() {

      if (this.status_atEndMission) {
        // compute the feature vectors of the Next candidate canvasses NextCanvas1x
        let xp1 = this.im2arr(this.$refs['NextCanvas1x'],this.projx)
        let yp1 = this.im2arr(this.$refs['NextCanvas1y'],this.projy)
        let xp2 = this.im2arr(this.$refs['NextCanvas2x'],this.projx)
        let yp2 = this.im2arr(this.$refs['NextCanvas2y'],this.projy)

        // only execute when all are non-zero
        let r = (xp1.reduce( (a,c)=>a+Math.abs(c))
          * xp2.reduce( (a,c)=>a+Math.abs(c))
          * yp1.reduce( (a,c)=>a+Math.abs(c))
          * yp2.reduce( (a,c)=>a+Math.abs(c)))

        if (r  > 0){
            let v1 = 0
            for (let ix1=0; ix1<this.nx; ix1++) {
              for (let iy1=0; iy1<yp1.length; iy1++) {
                v1 += xp1[ix1]*yp1[iy1]*this.D[ix1][iy1];
              }}

            let v2 = 0
            for (let ix2=0; ix2<this.nx; ix2++) {
              for (let iy2=0; iy2<yp2.length; iy2++) {
                v2 += xp2[ix2]*yp2[iy2]*this.D[ix2][iy2];
              }}

            console.log("D is set to", this.D)
            console.log("SearchAI successfully loaded! AI accuracies are:", v1, v2)
            console.log("The next mission will be", ((v1>v2) ? this.nextImg2 : this.nextImg1))
            this.nextImg = (v1>v2) ? this.nextImg2 : this.nextImg1;
        }
        else {
          this.nextImg = this.nextImg1}
        // dummy
        // return Math.floor(150000*Math.random())
      }
      return this.nextImg
    },






    // Draw the Region of Interest (ROI) in temporary canvases. These regions
    // are later on used to compute the correlation of a matching
    drawROI: function(img) {
      let which = '1'
      if (img.id === 'konvaImg2')
        which = '2'

      const tempCanvas = this.$refs['tempCanvas' + which]
      const tempImg = this.$refs['tempImg' + which]
      const {konvaImg1, konvaImg2, ROISize} = this

      // Compute the crop start/end points and its size
      const borderSize = 0
      // Retrieve x/y scale of image (which varies depending on what
      // transformation the user has performed to the image)
      const widthBase = this[img.id].width() * this[img.id].scaleX()
      const heightBase = this[img.id].height() * this[img.id].scaleY()
      const scaleX = (widthBase - borderSize) / tempImg.width
      const scaleY = (heightBase - borderSize) / tempImg.height
      let cropX = ((konvaImg1.width() - borderSize - ROISize) / 2) / scaleX
      let cropY = ((konvaImg1.height() - borderSize - ROISize) / 2) / scaleY
      let angle = this[img.id].rotation() * Math.PI / 180
       if (img.id === 'konvaImg2') {
         // cropX += ((konvaImg1.x() + konvaImg1.width()/2) - Math.cos(angle) * (konvaImg2.x() + konvaImg2.width()/2) + Math.sin(angle) * (konvaImg2.y() + konvaImg2.height()/2)) / scaleX
         // cropY += (konvaImg1.y() - Math.sin(angle) * konvaImg2.x() - Math.cos(angle) * konvaImg2.y()) / scaleY

         //works without rotation
         cropX += (konvaImg1.x() - konvaImg2.x()) / scaleX
         cropY += (konvaImg1.y() - konvaImg2.y()) / scaleY

       }
      const cropW = ROISize / scaleX
      const cropH = ROISize / scaleY

      // Draw image in canvas
      let ctx  = tempCanvas.getContext('2d')
      let tw = tempCanvas.width, th = tempCanvas.height
      ctx.clearRect(0, 0, tw, th)
      //ctx.save()

      ctx.translate(tw/2, th/2)
      // ctx.rotate(angle)
      // ctx.drawImage(img, cropX, cropY, cropW, cropH, -(Math.cos(angle) * tw - Math.sin(angle) * th)/2, -(Math.sin(angle) * tw + Math.cos(angle) * th)/2, ROISize, ROISize)
      ctx.drawImage(img, cropX, cropY, cropW, cropH, -tw/2, -th/2, ROISize, ROISize)
      // ctx.rotate(-angle)
      ctx.translate(-tw/2, -th/2)
      ctx.restore()
    },

    doImageMatching: function (img) {
      // Update ROI
      this.drawROI(img)
      const {ROISize} = this
      //TEST
      const xs = getRChannel(this.$refs['tempCanvas1'], ROISize)
      // Retrieve USNO equal sized objects if not already cache
      // let xsEqualSized = [...this.xsEqualSized]
      // if (xsEqualSized.length === 0) {
      //   // Binarize USNO ROI
      //   const xs = getRChannel(this.$refs['tempCanvas1'], ROISize)
      //   const xsBw = binarize(meanFilter(xs, ROISize), 80)
      //   // Label objects
      //   const xsObjects = labelObjects(xsBw, ROISize)
      //   // "Draw" equal sized objects in binary array
      //   xsEqualSized = Array(ROISize * ROISize).fill(0)
      //   Object
      //     .entries(getAsEqualSizedObjects(xsObjects, ROISize, xsBw.length, 9))
      //     .forEach((x) => x[1].forEach(p => xsEqualSized[p] = 255))
      //   // Save in cache
      //   this.xsEqualSized = [...xsEqualSized]
      // }

      // Binarize PanSTARR ROI
      const ys = getRChannel(this.$refs['tempCanvas2'], ROISize)
      // const ysBw = binarize(meanFilter(ys, ROISize), 110)
      // // Label objects
      // const ysObjects = labelObjects(ysBw, ROISize)
      // // "Draw" equal sized objects in binary array
      // let ysEqualSized = Array(ROISize * ROISize).fill(0)
      // Object
      //   .entries(getAsEqualSizedObjects(ysObjects, ROISize, ysBw.length, 13))
      //   .forEach((y) => y[1].forEach(p => ysEqualSized[p] = 255))

      // // Subtract USNO and PanSTARR pre-processed images
      // // const zs = subtract(xsEqualSized, ysEqualSized)

      // const numXsObjs = xsEqualSized.filter(x => x > 0).length
      const eventName = 'accuracy-change'
      const accuracy = (computeCorrelation(xs, ys))
      this.$emit(eventName, {accuracy, isAccuracyValid: true})
      this.updateAI(this.isAccuracyValid)
    },


    // Draws a 1d array of pixel value intensities (0-255) in a canvas with id
    // equal to `id`
    drawArrayInCanvas: function (xs, canvasId) {
      let ctx  = this.$refs[canvasId].getContext('2d')
      for(let i = 0; i < this.ROISize; i++) {
        for(let j = 0; j < this.ROISize; j++) {
          const val = xs[i * this.ROISize + j]
          ctx.fillStyle = `rgba(${val}, ${val}, ${val}, 1)`
          ctx.fillRect(j, i, 1, 1)
        }
      }
    },
    // Draw objects in canvas with id equal to `id`, where `objects` is a
    // dictionary where keys represent a label and values an array of the
    // pixels which belong to such label
    drawObjectsInCanvas: function(objects, canvasId) {
      // Colors to be used to draw the objects
      const colors = [
        'Blue', 'BlueViolet', 'Coral', 'DarkGreen', 'DarkRed', 'DeepPink',
        'HotPink', 'Red', 'Plum', 'NavajoWhite', 'Black'
      ]
      // Assign a color to each object
      const xs = Array(this.ROISize * this.ROISize).fill('white')
      Object.keys(objects).forEach(l => {
        objects[l].forEach(i => {
          xs[i] = colors[l < colors.length ? l : l % colors.length]
        })
      })
      // Draw array in `canvasId`
      let ctx  = this.$refs[canvasId].getContext('2d')
      for(let i = 0; i < this.ROISize; i++) {
        for(let j = 0; j < this.ROISize; j++) {
          ctx.fillStyle = xs[i * this.ROISize + j]
          ctx.fillRect(j, i, 1, 1)
        }
      }
    },
    initializeKonvaStage: function () {
      const {width, height} = this
      const halfInnerWidth = width / 2
      if (width > height) {
        // TODO: Do something about the +- 5 (better variable name?)
        this.konvaImg1.x(halfInnerWidth - this.konvaImg1.width() - 5)
        this.konvaImg2.x(halfInnerWidth + 5)
      } else {
        this.konvaImg1.width(halfInnerWidth)
        this.konvaImg1.height(halfInnerWidth)
        this.konvaImg1.x(halfInnerWidth - this.konvaImg1.width()/2)
        this.konvaImg2.width(halfInnerWidth)
        this.konvaImg2.height(halfInnerWidth)
        this.konvaImg2.x(halfInnerWidth - this.konvaImg2.width()/2)
      }

      // Add filter settings
      ['konvaImg1', 'konvaImg2'].forEach((x) => this.configureImageFilters(x))

      let stage = new Konva.Stage({container: 'container', width, height})

      this.imgLayer = new Konva.Layer()
      stage.add(this.imgLayer)

      this.imgLayer.add(this.konvaImg1)
      this.imgLayer.add(this.konvaImg2)
      this.drawBoundingBox(this.imgLayer.getContext(), {left: 0, right:0, width: this.imgLayer.width, height: this.imgLayer.height})
      this.bindMouseEvents(stage)

      // create new transformer
      this.transformer = new Konva.Transformer({
        anchorStroke: 'none',
        anchorFill: '#342',
        anchorSize: 15,
        borderStroke: '#99ee99',
        borderDash: [5, 5],
        keepRatio: false,
        rotateEnabled: true
      })
      this.imgLayer.add(this.transformer)
      this.transformer.attachTo(this.konvaImg2)
      // set the blending style of the two images
      // unfortunately it affects also the control nodes, which needs to be fixed
      this.imgLayer.getContext().globalCompositeOperation = "difference"
      this.imgLayer.draw()
      this.bindKeyboardEvents()
    },
    // Setup an image in Konva once it has been loaded
    onLoadImgFinished1: function(event) {
      // Reset cached values every time a new image is loaded
      this.xsEqualSized = []
      // Re-configure Konva
      console.log("Loading finished", event.target.id)
      const imgId = event.target.id
      // this[imgId].clearCache()
      this[imgId].image(event.target)
      this.handleImgPositionChange(event.target)
      this.configureImageFilters(imgId)
      this.imgLayer.draw()
    },

    onLoadImgFinished2: function(event) {
      try {
        // Reset cached values every time a new image is loaded
        this.xsEqualSized = []
        // Re-configure Konva
        console.log("Loading finished", event.target.id)
        const imgId = event.target.id
        // this[imgId].clearCache()
        this[imgId].image(event.target)
        this.handleImgPositionChange(event.target)
        this.configureImageFilters(imgId)
        this.imgLayer.draw()
        this.onLoadImgAi()
      } catch(e) {
        this.$emit('aiAccuracy',100)
        this.onLoadImgNext()
        console.log('an error occured during loading', e)}

      this.$store.dispatch('toggleLoading',false)
    },

    onLoadImgAi: function () {
      const ctx1 = this.$refs["ai1"].getContext("2d");
      ctx1.drawImage(document.getElementById("konvaImg1"), 0, 0, document.getElementById("konvaImg1").width, document.getElementById("konvaImg1").height)
      const ctx2 = this.$refs["ai2"].getContext("2d");
      ctx2.drawImage(document.getElementById("konvaImg2"), 0, 0, document.getElementById("konvaImg2").width, document.getElementById("konvaImg2").height)

      this.$emit('aiAccuracy', this.computeAIAccuracy());
      this.onLoadImgNext()
    },

    //  Draw the images with ID = this.NextIm1, this.Next2 in the respective
    // canvasses with IDs Next1x, Next1y, Next2x, Next2y
    onLoadImgNext: function () {
      // choose 2 random missions
      this.nextImg1 = Math.floor(150000*Math.random())
      this.nextImg2 = Math.floor(150000*Math.random())
      console.log("The 2 next candidates are set to:", this.nextImg1 , this.nextImg2 )

      this.NextUsnoSrc1 = 'http://r01.ds.cs.umu.se/getimage_mongo_v2.php?image=' + this.nextImg1 + '&filter=1&cat=USNO'
      this.NextPS1Src1  = 'http://r01.ds.cs.umu.se/getimage_mongo_v2.php?image=' + this.nextImg1 + '&filter=1&cat=PS1'
      this.NextUsnoSrc2 = 'http://r01.ds.cs.umu.se/getimage_mongo_v2.php?image=' + this.nextImg2 + '&filter=1&cat=USNO'
      this.NextPS1Src2  = 'http://r01.ds.cs.umu.se/getimage_mongo_v2.php?image=' + this.nextImg2 + '&filter=1&cat=PS1'

      // draw the images on the resp. canvasses
      let ctx1 = document.getElementById("NextCanvas1x").getContext("2d");
      ctx1.drawImage(document.getElementById('NextImg1x'), 0, 0, document.getElementById('NextImg1x').width, document.getElementById('NextImg1x').height)
      let ctx2 = document.getElementById("NextCanvas1y").getContext("2d");
      ctx2.drawImage(document.getElementById('NextImg1y'), 0, 0, document.getElementById('NextImg1y').width, document.getElementById('NextImg1y').height)
      let ctx3 = document.getElementById("NextCanvas2x").getContext("2d");
      ctx3.drawImage(document.getElementById('NextImg2x'), 0, 0, document.getElementById('NextImg2x').width, document.getElementById('NextImg2x').height)
      let ctx4 = document.getElementById("NextCanvas2y").getContext("2d");
      ctx4.drawImage(document.getElementById('NextImg2y'), 0, 0, document.getElementById('NextImg2y').width, document.getElementById('NextImg2y').height)
    },

    drawBoundingBox: function(ctx, bbox){
        ctx.strokeStyle="#FF0000";
        ctx.lineWidth=1;
        ctx.beginPath();

        // top
        ctx.moveTo(bbox.left+0.5, bbox.top + 0.5);
        ctx.lineTo(bbox.right+0.5 ,bbox.top + 0.5);
        ctx.stroke();

        // right
        ctx.lineTo(bbox.right+0.5 ,bbox.bottom + 0.5);
        ctx.stroke();

        // bottom
        ctx.lineTo(bbox.left+0.5, bbox.bottom + 0.5);
        ctx.stroke();

        // left
        ctx.lineTo(bbox.left+0.5, bbox.top + 0.5);
        ctx.stroke();
    },
    // Handles updates that need to be performed when an image position has changed
    handleImgPositionChange: function(target) {
      this.doImageMatching(target)
      const getImgTransformations = (img) => {
        const {x, y, width, height, rotation, scaleX, scaleY} = img.attrs
        return {
          x, y, width, height, rotation,
          'scale_x': scaleX,
          'scale_y': scaleY
        }
      }
      this.$store.dispatch(IMG__UPDATE_TRANSFORMATION, {
        imageOne: getImgTransformations(this.konvaImg1),
        imageTwo: getImgTransformations(this.konvaImg2)
      })
    },
    // Update threshold value
    handleThresholdValueChange: function (imgId, value) {
      this.$store.dispatch(IMG__UPDATE_THRESHOLD_VALUE, {imgId, value})
    },
    // Toggle threshold filter active state
    handleToggleThreshold: function(imgId) {
      this.$store.dispatch(IMG__TOGGLE_THRESHOLD, imgId)
    },
    // Configure active filters in an image
    configureImageFilters: function(imgId) {
      const {filters} = this
      this[imgId].cache()
      if (filters[imgId].hasThreshold) {
        this[imgId].filters([Konva.Filters.Threshold])
        this[imgId].threshold(filters[imgId].thresholdValue/100)
      } else {
        this[imgId].filters([])
      }
    },
    bindKeyboardEvents: function() {
      window.addEventListener('keydown', function(event) {
        switch(event.keyCode) {
          case KEY_CODES.SPACE:
            this.$emit('next')
            break
          case KEY_CODES.PERCENT_SIGN:
            event.preventDefault();
            this.konvaImg2.move({x: -1, y: 0})
            break
          case KEY_CODES.AMPERSAND:
            event.preventDefault();
            this.konvaImg2.move({x: 0, y: -1})
            break
          case KEY_CODES.APOSTROPHE:
            event.preventDefault();
            this.konvaImg2.move({x: 1, y: 0})
            break
          case KEY_CODES.LEFT_PARENTHESIS:
            event.preventDefault();
            this.konvaImg2.move({x: 0, y: 1})
            break
          case KEY_CODES.DIGIT_1:
            if (event.target.nodeName !== "INPUT") {
              event.preventDefault();
              this.konvaImg2.hide()
            }
            break
          case KEY_CODES.DIGIT_2:
            if (event.target.nodeName !== "INPUT") {
              event.preventDefault();
              this.konvaImg1.hide()
            }
            break
          case KEY_CODES.DIGIT_3:
            if (event.target.nodeName !== "INPUT") {
              event.preventDefault();
              this.toggleBlink()
            }
            break
        }
        this.imgLayer.draw()
      }.bind(this))

      window.addEventListener('keyup', function(event) {
        switch(event.keyCode) {
          case KEY_CODES.DIGIT_1:
            this.konvaImg2.show()
            break
          case KEY_CODES.DIGIT_2:
            this.konvaImg1.show()
            break
        }
        this.imgLayer.draw()
      }.bind(this))
    },
    bindMouseEvents: function(stage) {
      this.konvaImg2.on('mouseenter', function () {
        stage.container().style.cursor = 'move'
      }.bind(this))
      this.konvaImg2.on('mouseleave', function () {
        stage.container().style.cursor = 'default'
      }.bind(this))
    },
    toggleBlink: function() {
      if (!this.blinking) {
        this.blinkingEngine = window.setInterval(function() {
          if (this.blink) {
            this.konvaImg2.show()
            this.konvaImg1.hide()
          }
          else {
            this.konvaImg1.show()
            this.konvaImg2.hide()
          }
          this.imgLayer.draw()
          this.blink = !this.blink
        }.bind(this), 400)
        this.blinking = true
      }
      else {
        this.blinking = false
        window.clearInterval(this.blinkingEngine)
        this.konvaImg1.show()
        this.konvaImg2.show()
        this.imgLayer.draw()
      }
    }
  }
}
</script>

<style scoped>
  .hidden {
    display: none;
  }
  .tempCanvases {
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 9999;
    /*display: none;*/
  }
  .star-matching__object-canvases {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 9999;
    display: none;
  }
  .thresholds-wrapper {
    font-family: 'Overpass Mono', monospace;
    color: #200;
    text-shadow: 1px 1px 1px rgba(255,255,255,0.5);
    position: absolute;
    left: 0;
    top: 0;
    width:80px;
    box-shadow: inset 0 0 7px #000;
    height:100vh;
    border-radius: 3px;
  }
  .threshold-container {
    display: inline-block;
    margin: 0 13px;
    text-align: center;
    width:55px;
  }
  .threshold-button, .blink-button {
    margin-top:0.5em;
    margin-bottom: 0.5em;
    font-family: 'Overpass Mono', monospace;
    font-size:10pt;
    display: block;
    width: 55px;
    height: 30px;
    border-radius: 4px;
    background: radial-gradient(#668866, #557755);
    color: #242;
    border: 0;
    line-height: 6pt;
    font-weight: 500;
    box-shadow: 1px 1px 0px 1px rgba(0,0,0,0.5);
    cursor: pointer;
    text-shadow: 1px 1px 1px rgba(255,255,255, 0.5);
    outline: none;
    border:1px solid rgba(0,0,0,0.5);
  }
  .threshold-button {
    width: 35px;
    height: 35px;
    border-radius: 18px;
    margin-left: 10px;
  }
  .threshold-button:hover, .threshold-active, .blink-button:hover, .blink-button:active {
    background: radial-gradient(#99ee99, #66cc66);
    box-shadow: 1px 1px 3px 3px rgba(200,255,200,0.5);
  }
  .blink-button {
    margin: 0 auto 2em;
  }
  .star-matching__warning-container {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 10px;
    z-index: 1;
  }
  .star-matching__warning-text {
    padding: 10px;
    background: #ffffff;
    color: black;
    border: 2px solid #c58347;
    border-radius: 4px;
    margin: 0px auto;
  }
</style>
